import React, {useEffect} from "react";
import { useSelector } from "react-redux";
import Draggable from "react-draggable";

const RenderRowReply = (rowData) => {
    return (
        <li>
            <div className={"header"} style={{cursor:"pointer"}} >
                <p className={"name"}>{rowData.userNm}</p>
                <p className={"time"}>{rowData.createDt}</p>
                <div dangerouslySetInnerHTML={{ __html: rowData.content }} suppressHydrationWarning></div>
            </div>
        </li>
    );
};

const RenderRow = (rowData) => {
    const userSelector = useSelector((store) => store.user);
    const sheetCodeOwners = rowData.templateOwners?.filter((f) => f.sheetCode === rowData.sheetCode)
    const completeRender = React.useMemo(() => {
        const { cmptType } = rowData;
        if (cmptType === "R") {
            return <span>Not Complete</span>;
        } else if (cmptType === "C") {
            return <span>Completed</span>;
        }
    }, [rowData]);

    return (
        <li className={`${rowData.cmptType === "C" ? "completed" : ""}`} >
            <div className={`d-flex justify-between wrap`} style={{cursor:"pointer"}} onClick={() => rowData.clickAction(rowData.uniqueCode, rowData.celNm, rowData.revType)}>
                <div className={"header"} >
                    <p className={"name"}>{rowData.userNm}</p>
                    <p className={"time"}>{rowData.createDt}</p>
                </div>
                {rowData.tempYn === "N" && rowData.commentType === "desc" ? (
                    ""
                ):(
                    (sheetCodeOwners[0].userId === userSelector.userId) || (rowData.pcsOwnerId === userSelector.userId) ? (
                        <div
                            className={`info true ${rowData.cmptType}`}
                            // onClick={HandleComplete}
                        >
                            {completeRender}
                        </div>
                    ) : (
                        <div
                            className={`info ${
                                userSelector.userId === rowData.userId &&
                                rowData.revInfo?.reviewEnd === "N" &&
                                rowData.revInfo?.reviewing === "I"
                            } ${rowData.cmptType}`}
                            // onClick={HandleComplete}
                        >
                            {completeRender}
                        </div>
                    )
                )}
                <div className={"content"} style={{border: "none",boxShadow:"none"}} dangerouslySetInnerHTML={{ __html: rowData.content }} suppressHydrationWarning ></div>
            </div>
            <div className={`rereply-wrapper }`}>
                {/*{rowData?.comn.length > 0 && <div className={"rereply-hidebtn"} onClick={() => SetReplyView(!ReplyView)}></div>}*/}

                <ul className={"review rereply-list"} onClick={() => rowData.clickAction(rowData.uniqueCode, rowData.celNm, rowData.revType)}>
                    {rowData?.comn.map((rowData, index) => {
                        return <RenderRowReply key={`rereply-${index}`} {...rowData} />;
                    })}
                </ul>
                {rowData.revInfo?.reviewing === "I" &&
                    rowData.revInfo?.reviewEnd === "N" &&
                    rowData?.cmptType !== "C" &&
                    rowData?.tempYn === "Y" && (
                        <div className={"review  input-group"}>
                        </div>
                    )}
            </div>
            {/*{ModalData && <ModalPortal>{ModalData}</ModalPortal>}*/}
        </li>
    );
};

const ReviewComponentV2 = (props) => {
    const { templateOwners, pcsOwnerId } = props;
    const [Data, SetData] = React.useState(null);
    const CanDragRef = React.useRef(false);
    const windowScroll = React.useRef(0);
    const RevUserRef = React.useRef([]);

    const getData = React.useCallback(async () => {
        if(!props?.comment.doc.revInfo) return;
        let revInfo = props.comment.doc.revInfo;
        let dataInfo = props.filterAction;
        SetData((OLD) => ({ revInfo, dataInfo }));
    }, [props]);

    useEffect(() => {
        getData();
    }, [getData, props]);

    const renderList = React.useMemo(() => {
        if (Data) {
            const { revInfo, dataInfo } = Data;
            if (dataInfo.length > 0) {
                return (
                    <ul className={"review"} >
                        {dataInfo?.map((rowData, index) => {
                            return (
                                <RenderRow
                                    {...rowData}
                                    refresh={props.refresh || getData}
                                    revInfo={revInfo}
                                    getData={props.refresh || getData}
                                    revtype={dataInfo.revType}
                                    userList={RevUserRef.current}
                                    key={`reviewList${index}`}
                                    clickAction = {props.clickAction}
                                    sheetType = {props.rowData}
                                    templateOwners={templateOwners?.Owners}
                                    pcsOwnerId={pcsOwnerId}
                                />
                            );
                        })}
                    </ul>
                );
            } else {
                return <div className={"review-no"}>No Review</div>;
            }
        } else {
            return <div className={"review-no"}>No Review</div>;
        }
    }, [Data, getData]);

    return (
        <Draggable
            onStart={() => {
                return CanDragRef.current;
            }}
        >
            <div
                className={"bpl-review-content-popupV2"}
                style={{ top: 150 - windowScroll.current, right: props.positionX, display: Data ? null : "none" }}
            >
                {Data && (
                    <div className={"bpl-review-content-popupV2-wrap"}>
                        <div className={"content"} style={{border: "none"}}>{renderList}</div>
                    </div>
                )}
            </div>
        </Draggable>
    );
};

export default ReviewComponentV2;
